import { render } from "./certificates.vue?vue&type=template&id=3078892d"
import script from "./certificates.vue?vue&type=script&lang=js"
export * from "./certificates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/certificates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3078892d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3078892d', __exports__)) {
    api.reload('3078892d', __exports__)
  }
  
  module.hot.accept("./certificates.vue?vue&type=template&id=3078892d", () => {
    api.rerender('3078892d', render)
  })

}


export default __exports__